import PropTypes from "prop-types";
import { Script } from "gatsby";

export const Seo = ({ meta, title, metaImage, path, description, site, canonicalURL }) => {
  // fallback code
  let googleTagManagerCode = "GTM-T7CP3Q";

  //TODO refactor to use Sanity settings
  if (site === "cla") {
    googleTagManagerCode = "GTM-NZZQP48";
  } else if (site === "graduate") {
    googleTagManagerCode = "GTM-TJMW9X6";
  } else if (site === "professional-advancement") {
    googleTagManagerCode = "GTM-MG6XW8Z";
  }
  const canonicalPath = canonicalURL ?? path
  return (
    <>
      <Script
        id={`gtm-code`}
      >{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer', '${googleTagManagerCode}');`}</Script>
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="referrer" content="origin" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${path}/`} />
      <meta property="og:type" content="website" />

      <meta
        property="og:image"
        content={
          metaImage !== undefined && metaImage.url && metaImage.url.length > 0
            ? `${metaImage.url}?fit=max&w=1200&h=630&format=auto`
            : "https://cdn.sanity.io/images/qe2ul2l0/production/8acf00387839ea9e7d2f5600c841b4bd101f083e-1200x630.jpg?fit=max&w=1200&h=630&format=auto"
        }
      />
      <meta
        property="og:image:width"
        content={
          metaImage !== undefined &&
          metaImage.url &&
          metaImage.url.length > 0 &&
          metaImage.width > 0
            ? metaImage.width
            : "1200"
        }
      />
      <meta
        property="og:image:height"
        content={
          metaImage !== undefined &&
          metaImage.url &&
          metaImage.url.length > 0 &&
          metaImage.height > 0
            ? metaImage.height
            : "630"
        }
      />
      <meta name="twitter:card" content="summary_large_image" />
      {meta}
      <title>{title}</title>

      {canonicalPath && <link rel="canonical" href={`${canonicalPath}${canonicalPath.endsWith('/') ? '' : '/' }`} />}
    </>
  );
};

Seo.defaultProps = {
  lang: `en-US`,
  meta: [],
  dir: `ltr`,
};

Seo.propTypes = {
  lang: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
};

export default Seo;
